import { store } from "@betacrew/jars-flux"
import { PAGE_STATE } from "../../constants/constants";

export const componentKey = "FORMS/SUBMIT"

const {actions} = store.reducerManager.add({
    key: componentKey,
    addedReducers:{
        setLoadingState:(state, action) =>{
            state.loadingState = action.payload
        },
        setCurrentTabIndex: (state, action) => {
            state.currentTabIndex = action.payload
        }
    },
    initialReducerState: {
        loadingState: {state: PAGE_STATE.PAGE_READY, message: ""},
        currentTabIndex: 0
    }
})

export const{setLoadingState, setCurrentTabIndex} = actions;